import { useMemo } from 'react'
import { useIsMobileDevice } from '../../../shared/hooks/useIsMobileDevice'

const MOBILE_SCALE = 1 / 1.5

export type LayoutConstants = {
    ROW_HEADER_WIDTH: number
    SLOT_HANDLE_WIDTH: number
    COLUMN_WIDTH: number
    SCROLL_START: number
}

export const useLayoutConstants = (): LayoutConstants => {
    const isMobileDevice = useIsMobileDevice()

    return useMemo(() => {
        const scale = isMobileDevice ? MOBILE_SCALE : 1
        const ROW_HEADER_WIDTH = 250 * scale
        const SLOT_HANDLE_WIDTH = 32 * scale
        const COLUMN_WIDTH = 320 * scale
        const SCROLL_START = ROW_HEADER_WIDTH + SLOT_HANDLE_WIDTH
        return {
            ROW_HEADER_WIDTH,
            SLOT_HANDLE_WIDTH,
            COLUMN_WIDTH,
            SCROLL_START,
        }
    }, [isMobileDevice])
}
